exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.buttons .join-button{width:100%}[dir] .buttons .join-button{margin-bottom:20px}@media (min-width:1200px){.buttons .join-button{width:50%}[dir] .buttons .join-button{margin-bottom:0}[dir=ltr] .buttons .join-button{margin-right:30px}[dir=rtl] .buttons .join-button{margin-left:30px}}.buttons .sign-button{width:100%}@media (min-width:1200px){.buttons .sign-button{width:50%}}[dir] .reservation-user-info{background-color:#f4f2ed}.amb-logo{max-width:316px}[dir] .override-button{background-color:#3f3d3d}.association-component a{text-decoration:underline}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/reservation-association/reservation-association.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/reservation-association/reservation-association.component.scss
// module chunks = 0